export default "__VITE_ASSET__BI48ZZj6__"